/*Состояния*/
const state = () => ({
  show: false,
  color: "",
  size: "",
  opacity: "",
});
export { state };
